module.exports = __webpack_public_path__ + "fonts/TikTokDisplayRegular.eb1756e4.otf";